import { gql } from '@apollo/client'
// graphql
import { FIELD_FRAGMENT } from 'graphql/field/queries'
// types
import { FieldSource } from 'types/graphql'

export const OBJECT_ENTITIES_QUERY = gql`
  query OBJECT_ENTITIES_QUERY($filter: ObjectEntityFilterInput, $order: OrderInput, $pagination: PaginationInput) {
    objectEntities(filter: $filter, order: $order, pagination: $pagination) {
      data {
        id
        apiName
        name
        ownerObjectSecurityId
        ownerObjectSecurity {
          id
          name
        }
        memberObjectSecurityId
        memberObjectSecurity {
          id
          name
        }
        fields {
          ...FIELD
        }
        reviewQuestions {
          id
          position
          text
        }
        reviewFieldIds
      }
      pagination {
        pageSkip
        pageTake
        totalCount
      }
    }
  }
  ${FIELD_FRAGMENT}
`

export const OBJECT_ENTITIES_SELECT_QUERY = gql`
  query OBJECT_ENTITIES_SELECT_QUERY($filter: ObjectEntityFilterInput) {
    objectEntities(filter: $filter) {
      data {
        id
        apiName
        name
      }
    }
  }
`

export const PLAN_SELECT_QUERY = (source: FieldSource) => `
  ${source}: plans(filter: $planFilter, pagination: $pagination) {
    data {
      id
      name
      companyId
    }
  }
`

export const PLAN_TYPES_SELECT_QUERY = (source: FieldSource) => `
  ${source}: planTypes(filter: $planTypeFilter, pagination: $pagination) {
    data {
      id
      active
      description
    }
  }
`

export const PLAN_ACTIONS_SELECT_QUERY = (source: FieldSource) => `
  ${source}: planActions(filter: $actionFilter, pagination: $pagination) {
    data {
      id
      description
    }
  }
`

export const PLAN_OBJECTIVES_SELECT_QUERY = (source: FieldSource) => `
  ${source}: planObjectives(filter: $objectiveFilter, pagination: $pagination) {
    data {
      id
      description
    }
  }
`

export const PLAN_KPIS_SELECT_QUERY = (source: FieldSource) => `
  ${source}: planKPIs(filter: $kpiFilter, pagination: $pagination) {
    data {
      id
      description
    }
  }
`

export const USERS_SELECT_QUERY = (source: FieldSource) => `
  ${source}: users(filter: $userFilter, pagination: $pagination) {
    data {
      id
      active
      email
      firstName
      lastName
      companyId
      displayName
      businessUnits {
        id
        description
      }
    }
  }
`

export const USERS_PUBLIC_SELECT_QUERY = (source: FieldSource) => `
  ${source}: usersPublic(domain: $domain, filter: $userFilter, pagination: $pagination) {
    data {
      id
      active
      email
      firstName
      lastName
      displayName
    }
  }
`

export const POSITIONS_SELECT_QUERY = (source: FieldSource) => `
  ${source}: positions(filter: $positionFilter, pagination: $pagination) {
    data {
      id
      active
      description
      user {
        id
        businessUnits {
          id
          description
        }
      }
      parent {
        id
        description
      }
    }
  }
`

export const POSITIONS_PUBLIC_SELECT_QUERY = (source: FieldSource) => `
  ${source}: positionsPublic(domain: $domain, filter: $positionFilter, pagination: $pagination) {
    data {
      id
      active
      description
    }
  }
`

export const BUSINESS_ACTIVITIES_SELECT_QUERY = (source: FieldSource) => `
  ${source}: businessActivities(filter: $businessActivityFilter, pagination: $pagination) {
    data {
      id
      active
      description
    }
  }
`

export const BUSINESS_PROCESSES_SELECT_QUERY = (source: FieldSource) => `
  ${source}: businessProcesses(filter: $businessProcessesFilter, pagination: $pagination) {
    data {
      id
      active
      description
    }
  }
`

export const BUSINESS_UNITS_SELECT_QUERY = (source: FieldSource) => `
  ${source}: businessUnits(filter: $businessUnitFilter, pagination: $pagination) {
    data {
      id
      active
      description
    }
  }
`

export const BUSINESS_UNITS_PUBLIC_SELECT_QUERY = (source: FieldSource) => `
  ${source}: businessUnitsPublic(domain: $domain, filter: $businessUnitFilter, pagination: $pagination) {
    data {
      id
      active
      description
    }
  }
`

export const LOCATIONS_SELECT_QUERY = (source: FieldSource) => `
  ${source}: locations(filter: $locationsFilter, pagination: $pagination) {
    data {
      id
      active
      description
    }
  }
`

export const LOCATIONS_PUBLIC_SELECT_QUERY = (source: FieldSource) => `
  ${source}: locationsPublic(domain: $domain, filter: $locationsFilter, pagination: $pagination) {
    data {
      id
      active
      description
    }
  }
`

export const RISK_SELECT_QUERY = (source: FieldSource) => `
  ${source}: getRisksForFieldSearch(ids: $risksFilter) {
    id
    label
    riskTemplateId
  }
`

export const RISK_SELECT_PUBLIC_QUERY = (source: FieldSource) => `
  ${source}: getRisksForFieldSearchPublic(domain: $domain, ids: $risksFilter) {
    id
    label
    riskTemplateId
  }
`

export const ENTITY_SELECT_QUERY = (data: { variables: string[]; queries: string[] }) => gql`
    query ENTITY_SELECT_QUERY ${data.variables.length ? `(${data.variables.join(', ')})` : ''} {${data.queries.join('\n')}}
`
